import axios from "@/utils/axios";
var broker = '/broker'
//查询代理商状态
export function checkIsAgentState () {
    return axios({
        method: 'get',
        url: broker + '/v3/broker/apply/status',
    })
}